import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon';

export const ContactIcon: ComponentWithAs<'svg', IIconProps> = (props) => {
  return (
    <Icon
      data-testid="contact-icon"
      boxSize={4}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.80403 8.35317C2.52389 10.9561 2.53637 13.9581 2.9262 16.5504C3.1419 17.9848 4.31257 19.0844 5.75763 19.21L7.26787 19.3413C10.4169 19.6151 13.5838 19.6151 16.7328 19.3413L18.2431 19.21C19.6881 19.0844 20.8588 17.9848 21.0745 16.5504C21.4643 13.958 21.4768 10.9562 21.1967 8.35333C21.1605 8.05157 21.1197 7.75021 21.0745 7.44936C20.8588 6.01497 19.6881 4.91533 18.243 4.78971L16.7328 4.65843C13.5838 4.38469 10.4169 4.38469 7.26787 4.65843L5.75763 4.78971C4.31256 4.91533 3.1419 6.01497 2.9262 7.44936C2.88096 7.75016 2.84024 8.05146 2.80403 8.35317ZM7.39777 6.1528C10.4604 5.88657 13.5403 5.88657 16.6029 6.15279L18.1131 6.28408C18.8675 6.34965 19.4786 6.92367 19.5912 7.67242C19.6029 7.75018 19.6142 7.82797 19.6253 7.9058L14.0643 10.9952C12.7807 11.7084 11.2199 11.7084 9.93632 10.9952L4.37539 7.90583C4.38645 7.828 4.39783 7.75019 4.40952 7.67242C4.52211 6.92367 5.13321 6.34965 5.88754 6.28408L7.39777 6.1528ZM19.8088 9.51976C20.0028 11.7875 19.9303 14.0724 19.5912 16.3273C19.4786 17.0761 18.8675 17.6501 18.1131 17.7157L16.6029 17.847C13.5403 18.1132 10.4604 18.1132 7.39777 17.847L5.88754 17.7157C5.13321 17.6501 4.52211 17.0761 4.40952 16.3273C4.07043 14.0724 3.99787 11.7875 4.19184 9.5198L9.20786 12.3065C10.9445 13.2713 13.0561 13.2713 14.7928 12.3065L19.8088 9.51976Z"
        fill="currentColor"
      />
    </Icon>
  );
};
